import Vue from 'vue';
import store from '@@/assets/js/store';
import apis from '@@/assets/js/apis';
import jwt from 'jsonwebtoken';
import qs from 'qs';
import axios from 'axios';

let refreshToken = true;

axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? global.URL_DEV_API_BASE_DOMAIN : process.env.VUE_APP_SERVER == 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN;

axios.defaults.timeout = 0; //不超时
axios.defaults.withCredentials = process.env.VUE_APP_IS_WITH_CREDENTIALS;
axios.defaults.headers = {
  'Content-Type': 'application/json',
  'X-requested-With': 'XMLHttpRequest'
  // "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};

//添加请求拦截器
axios.interceptors.request.use(config => {
  //如果有主动传入token,例如检验运维账号,那么优先用运维账号
  if (config.method === 'get') {
    // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
    config.paramsSerializer = function(params) {
      return qs.stringify(params, {
        arrayFormat: 'repeat'
      });
    };
  }

  if (config.token) {
    /* The line `config.headers["Authorization"] = config.token` is setting the Authorization header in the
HTTP request to the value of `config.token`. This header is commonly used for sending authentication
tokens or credentials to the server for secure access to protected resources. By setting this header
with the provided token value, the server can authenticate and authorize the client making the
request. */
    config.headers['Authorization'] = config.token;
  } else {
    //给所有请求添加Token
    let token = window.localStorage.getItem('token');
    config.headers['Authorization'] = token;
  }

  config.headers['Time-Zone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //临时取消
  //store.commit('SET_GLOBAL_LOADING', true);

  return config;
});
//添加响应拦截器，响应拦截器会在then/catch处理之前执行
axios.interceptors.response.use(
  response => {
    store.commit('SET_GLOBAL_LOADING', false);

    let DATA = JSON.parse(JSON.stringify(response.data), function(key, value) {
      if (value == null) {
        return undefined;
      }
      return value;
    });
    let data = DATA;

    //如果code不存在，那么就是其他接口了
    if (data.code == null) {
      return Promise.resolve(data);
    }
    //检查业务状态码为200
    // 返回完整请求
    if (data.code == 200) {
      return Promise.resolve(data);
    } else {
      //登录状态异常
      if (data.code == 40101004 || data.code == 20101004) {
        new Vue().utils.event_hub.$emit('NEED_LOGIN', null);
        return Promise.reject(data.msg);
      } else {
        // 其他业务状态异常
        console.log(data.msg + '||url:' + response.request.responseURL);
        return Promise.reject(data.msg);
      }
    }
  },
  err => {
    console.log(err.data);
    console.error('网络异常:%o', err);
    store.commit('SET_GLOBAL_LOADING', false);

    //发生网络错误后会走到这里
    return Promise.reject(err);
  }
);
// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function(Vue, Option) {
    Object.defineProperty(Vue.prototype, 'http', {
      value: axios
    });
  }
};
